import * as React from "react";
import { motion } from "framer-motion";
import { MenuItem } from "./Menuitem";

const variants = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 },
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 },
  },
};

export const Navigation = () => (
  <motion.ul variants={variants}>
    {itemIds.map((i, j) => (
      <MenuItem i={i} key={i} j={j} />
    ))}
  </motion.ul>
);

const itemIds = [0, 1];
